import {Map} from "es6-shim";
import { IObjectConfig} from "../baseConfigs/layoutConfigShema";

class ControllerManager {
    protected controllerMap: Map<string, any>


    init() {
        this.controllerMap = new Map();
    }

    addController(name: string, obj: any) {
        if (this.controllerMap.get(name)) {
            throw new Error(`Controller with name ${name} has already been set`);
        }
        this.controllerMap.set(name, obj);
    }

    getController(name: string) {
        return this.controllerMap.get(name);
    }

    removeController(name: string) {
        return this.controllerMap.delete(name);
    }
}

export default new ControllerManager();
